import React from 'react';
import { useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next';
import { Tooltip } from 'react-tooltip'

import moment from "moment/moment";
import 'moment/locale/es';
moment.locale('es');

import { useAxios } from '../../../hooks/useAxios'
import './home_cuatro.css';

import rel from '../../../assets/img/relo.png';
import Dot from '../../../assets/imgs/home_dos/dots.png'

import libertad from '../../../assets/imgs/home_cuatro/arte-y-cultura-ov.svg'


const Home_cuatro = () => {

    const [t, i18n] = useTranslation("home");
    const [g] = useTranslation("global");


    const { data, isloading } = useAxios(`https://www.ricardosalinas.com/S8JFmpfeLW5iUVROXz2owTPU/api/blogs/n?offset=0&next=4&lang=${i18n.language}`);
    const liga_lang = '/' + i18n.language + "/Ideas-en-libertad";
    const [blogs, setBlogs] = useState(null);
    const [activeImage, setActiveImagen] = useState(null);

    const handleImageClick = (index) => {
        setActiveImagen(index === activeImage ? null : index);
    };


    const numero = (txtresumen) => {
        // Verificar si txtresumen es una cadena y no es undefined
        if (typeof txtresumen === 'string' && txtresumen.trim() !== '') {
            // Realizar split por "||"
            const partes = txtresumen.split("||");

            // Verificar si hay una segunda parte
            if (partes.length > 1 && partes[1].trim() !== "") {
                return partes[1].trim(); // Si hay una segunda parte, retornarla
            }
        }

        // Si no hay una segunda parte o si txtresumen no es una cadena o es vacío,
        // realizar el cálculo actual
        const i = Math.floor(Math.random() * 4) + 1;
        return i;
    };

    const resumensplit = (txtresumen) => {
        // Verificar si txtresumen es una cadena y no es undefined
        if (typeof txtresumen === 'string' && txtresumen.trim() !== '') {
            // Realizar split por "||"
            const partes = txtresumen.split("||");

            // Verificar si hay una segunda parte
            if (partes.length > 1 && partes[0].trim() !== "") {
                return partes[0].trim(); // Si hay una segunda parte, retornarla
            }
        }

        return txtresumen;
    };

    useEffect(() => {
        if (data) {
            setBlogs(data);

        }
    }, [data])

    const formatDate = (date) => {
        const options = { day: "numeric", month: "long", year: "numeric" };

        // return new Date(date).toLocaleDateString(undefined, options);
        return new Date(date).toLocaleDateString(i18n.language, options);
    };


    const formatBackendDate = (date) => {
        try {
            const currentDate = new Date(date);
            const momentDate = moment(currentDate);
            return `${momentDate.format("DD")} ${momentDate.format("MMMM")}, ${momentDate.format("YYYY")}`
        } catch (err) {
            console.error("Error al parsear la fecha ", date, err);
            return "";
        }
    }

    if (isloading || blogs === null) {
        return (
            <div>Is loading...</div>
        )
    }

    return (
        <div className='Ultblogs'>
            <div className="contenedor escritorio">
                <div className="conRow1">
                    <p className="Entrada">{(t('last-entries.last'))}</p>
                    <a className='link_card_blg' href={'/blog/' + blogs[0].tag}><div className="row1">
                        <div className="col1">
                            <img className="imgG" src={blogs[0].urlImagen} alt={blogs[0].urlImagen} loading="lazy" />
                        </div>
                        <div className="col2">
                            <div className="datBlog">
                                <p className="fh_ub">{formatDate(blogs[0].fecha)}</p>
                                <p className="titulo_ub"><b>
                                    {blogs[0].titulo.split("La acción humana").map((part, index) => (
                                        <React.Fragment key={index}>
                                            {part}
                                            {index < blogs[0].titulo.split("La acción humana").length - 1 && (
                                                <i>La acción humana</i>
                                            )}
                                        </React.Fragment>
                                    ))}</b></p>
                                <p className="descrip_ub">{resumensplit(blogs[0].resumen)}</p>
                                <br></br><p className="descrip_ub"><b>{(t('by.by-who'))}</b></p>
                                <p className="alineIzq_ub"><img className="reloj " src={rel} alt="reloj"></img> &nbsp;&nbsp;{numero(blogs[0].resumen)}{(t('minutes.minutes-lecture'))}</p>
                            </div>
                            <div className='iconos_categoria'>
                                {blogs[0].categorias.map((categoria, index) => (
                                    <img
                                        key={index}
                                        className={`categ ${categoria.tagCategory}${activeImage === 1 ? 'active' : ''}  imgCat_ub dista` + (index + 1)}
                                        // REVISAR SVG NO FUNCIONA
                                        src={require(`../../../assets/img/${categoria.tagCategory}.svg`)}
                                        //src={`/assets/imgs/home_cuatro/${categoria.tagCategory}.png`} 
                                        alt={categoria.tagCategory}
                                        data-tooltip-id="tooltip-section1"
                                        data-tooltip-content={categoria?.nombre ?? ""}
                                        data-tooltip-place="top"
                                    />


                                ))}
                                <Tooltip
                                    id="tooltip-section1"
                                    className='customTooltip'
                                    arrowColor='transparent'
                                />
                            </div>
                        </div>
                    </div></a>
                </div>
                <div className="conRow1">
                    <p className="Ultima">{(t('last-entries.lastests'))}</p>
                    <div className="row2">
                        <div className="cont1">
                            <a className='link_card_blg' href={'/blog/' + blogs[1].tag}>
                                <img className="imgG2" src={blogs[1].urlImagen} alt={blogs[1].urlImagen} loading="lazy" />
                                <p className="titulo_ub2">{blogs[1].titulo.split("La acción humana").map((part, index) => (
                                    <React.Fragment key={index}>
                                        {part}
                                        {index < blogs[1].titulo.split("La acción humana").length - 1 && (
                                            <i>La acción humana</i>
                                        )}
                                    </React.Fragment>
                                ))}</p>
                                <div className="categ1">
                                    {blogs[1].categorias.map((categoria, index) => (
                                        <img
                                            key={index}
                                            className={`categ ${categoria.tagCategory}${activeImage === 1 ? 'active' : ''}  imgCat_ub2 dista2` + (index + 1)}
                                            src={require(`../../../assets/img/${categoria.tagCategory}.svg`)}
                                            alt={categoria.nombre}
                                            data-tooltip-id="tooltip-section2"
                                            data-tooltip-content={categoria?.nombre ?? ""}
                                            data-tooltip-place="top"
                                        />
                                    ))}
                                </div>
                                <Tooltip
                                    id="tooltip-section2"
                                    className='customTooltip'
                                    arrowColor='transparent'
                                />
                            </a>
                        </div>

                        <div className="cont2">
                            <a className='link_card_blg' href={'/blog/' + blogs[2].tag}>
                                <img className="imgG3" src={blogs[2].urlImagen} alt={blogs[2].urlImagen} loading="lazy" />
                                <p className="titulo_ub2">{blogs[2].titulo}</p>
                                <div className="categ2">
                                    {blogs[2].categorias.map((categoria, index) => (
                                        <img
                                            key={index}
                                            className={`categ ${categoria.tagCategory}${activeImage === 1 ? 'active' : ''}  imgCat_ub3 dista3` + (index + 1)}
                                            src={require(`../../../assets/img/${categoria.tagCategory}.svg`)}
                                            alt={categoria.nombre}
                                            data-tooltip-id="tooltip-section3"
                                            data-tooltip-content={categoria?.nombre ?? ""}
                                            data-tooltip-place="top"
                                        />
                                    ))}
                                </div>
                                <Tooltip
                                    id="tooltip-section3"
                                    className='customTooltip'
                                    arrowColor='transparent'
                                />
                            </a>
                        </div>

                        <div className="cont2">
                            <a className='link_card_blg' href={'/blog/' + blogs[3].tag}>
                                <img className="imgG3" src={blogs[3].urlImagen} alt={blogs[3].urlImagen} loading="lazy" />
                                <p className="titulo_ub2">{blogs[3].titulo}</p>
                                <div className="categ4">
                                    {blogs[3].categorias.map((categoria, index) => (
                                        <img
                                            key={index}
                                            className={`categ ${categoria.tagCategory}${activeImage === 1 ? 'active' : ''}  imgCat_ub4 dista4` + (index + 1)}
                                            src={require(`../../../assets/img/${categoria.tagCategory}.svg`)}
                                            alt={categoria.nombre}
                                            data-tooltip-id="tooltip-section4"
                                            data-tooltip-content={categoria?.nombre ?? ""}
                                            data-tooltip-place="top"
                                        />
                                    ))}
                                </div>
                                <Tooltip
                                    id="tooltip-section4"
                                    className='customTooltip'
                                    arrowColor='transparent'
                                />
                            </a>
                        </div>
                    </div>
                </div>
                <div className="conRow1">
                    <div className="div_bot">
                        <a className="buton" href={liga_lang} rel="noreferrer">{(g('general.all-entries'))}</a>
                    </div>
                </div>
            </div>

            <div className='squareTopRight'>
                <img src={Dot} alt='Imagen de cuadro con puntos' />
            </div>

            <div className='squareMiddleLeft'>
                <img src={Dot} alt='Imagen de cuadro con puntos' />
            </div>

            <div className='swuareBottomRight'>
                <img src={Dot} alt='Imagen de cuadro con puntos' />
            </div>

            {/* movil mas chiquito */}
            <div className="movil2">
                <p className="Entrada_mov"><strong>{(t('last-entries.last'))}</strong></p>
                <a className='link_card_blg' href={'/blog/' + blogs[0].tag}>
                    <img className="imgG_mov" src={blogs[0].urlImagen} alt={blogs[0].urlImagen} loading="lazy" />
                    <div className='dateContainer'>
                        <p className="dateText">
                            {formatBackendDate(blogs[0].fecha)} &nbsp; |
                        </p>
                        <p className="categoriesText">
                            {blogs[0].categorias.map((categoria) => (
                                categoria.nombre
                            )).join(" ")}
                        </p>
                    </div>

                    <div className="datBlog_mov">
                        <p className="titulo_ub_mov"><b>{blogs[0].titulo.split("La acción humana").map((part, index) => (
                            <React.Fragment key={index}>
                                {part}
                                {index < blogs[0].titulo.split("La acción humana").length - 1 && (
                                    <i>La acción humana</i>
                                )}
                            </React.Fragment>
                        ))}</b></p>
                        <p className="descrip_ub_mov">{resumensplit(blogs[0].resumen)}</p>
                        <div className="blogContainer">
                            <div className='leftContainer'>
                                {(t('by.by-who'))}
                            </div>
                            <div className='centerContainer'>
                                <img src={rel} alt="reloj" />
                                {numero(blogs[0].resumen)}{(t('minutes.minutes-lecture'))}
                            </div>
                            <div className='rightContainer'>
                                {blogs[0].categorias.map((categoria, index) => {
                                    return (
                                        <div className='imageSquareContainer' key={index}>
                                            <img src={`/assets/imgs/home_cuatro/${categoria.tagCategory}.png`} alt="" />
                                        </div>
                                    )
                                })}
                            </div>
                        </div>

                        {/* {blogs[0].categorias.map((categoria, index) => (
                        <img key={ index } className={"imgCat_ub_mov dista" + (index+1) +"_mov"} src={`/assets/imgs/home_cuatro/${categoria.tagCategory}.png`} alt={categoria.nombre}></img>
                    ))} */}
                    </div></a>

                <p className="Entrada_mov"><strong>{(t('last-entries.lastests'))}</strong></p>
                <a className='link_card_blg' href={'/blog/' + blogs[1].tag}><img className="imgG_mov" src={blogs[1].urlImagen} alt={blogs[1].urlImagen} loading="lazy" />
                    <p className="titulo_ub2_mov">{blogs[1].titulo}</p>
                    <div className="categ1">
                        {blogs[1].categorias.map((categoria, index) => (
                            <img className={"imgCat_ub_mov dista2" + (index + 1) + "_mov"} src={`/assets/imgs/home_cuatro/${categoria.tagCategory}.png`} alt={categoria.nombre}></img>
                        ))}
                    </div></a>
                <div className="row2_mov">
                    <div className="cont2_mov">
                        <a className='link_card_blg' href={'/blog/' + blogs[2].tag}>
                            <img className="imgG3_mov" src={blogs[2].urlImagen} alt={blogs[2].urlImagen} loading="lazy" />
                            <p className="titulo2_ub2_mov">{blogs[2].titulo}</p>
                        </a>
                    </div>
                    <div className="cont2_mov">
                        <a className='link_card_blg' href={'/blog/' + blogs[3].tag}>
                            <img className="imgG3_mov" src={blogs[3].urlImagen} alt={blogs[3].urlImagen} loading="lazy" />
                            <p className="titulo2_ub2_mov">{blogs[3].titulo}</p></a>
                    </div>
                </div>
                <div className="row3_mov">
                    <div className="cont2_mov">
                        <div className="categ2_mov">
                            {blogs[2].categorias.map((categoria, index) => (
                                <img className={"imgCat_ub_mov dista3" + (index + 1) + "_mov"} src={`/assets/imgs/home_cuatro/${categoria.tagCategory}.png`} alt={categoria.nombre}></img>
                            ))}
                        </div>
                    </div>

                    <div className="cont2_mov">
                        <div className="categ2_mov">
                            {blogs[3].categorias.map((categoria, index) => (
                                <img className={"imgCat_ub_mov dista4" + (index + 1) + "_mov"} src={`/assets/imgs/home_cuatro/${categoria.tagCategory}.png`} alt={categoria.nombre}></img>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="conRow2_mov_v2">
                    <div className="div_bot_mov">
                        <a className="buton_mov" href={liga_lang} rel="noreferrer">{(g('general.all-entries'))}</a>
                    </div>
                </div>
            </div>
        </div >
    );

}
export default Home_cuatro